import { OnboardingDetails } from '@/interfaces/onboarding';
import {
  BankPaymentOption,
  CardPaymentOption,
  PaymentOptionsStoreState
} from '@/interfaces/payment-options';

export function setLoading(state: PaymentOptionsStoreState, value: boolean) {
  state.loading = value;
}

export function setBankAccounts(
  state: PaymentOptionsStoreState,
  bankAccounts: BankPaymentOption
) {
  state.bankAccounts = bankAccounts;
}

export function setCards(
  state: PaymentOptionsStoreState,
  cards: CardPaymentOption
) {
  state.cards = cards;
}

export function setOnboardingDetails(
  state: PaymentOptionsStoreState,
  onboardingDetails: OnboardingDetails
) {
  state.onboardingDetails = onboardingDetails;
}
